module.exports = __webpack_public_path__ + "img/map_pc_4.5e71a32c.png";